import React from 'react';
import { Format, PreviewProps } from './types';
import { PreviewValue } from '../../PreviewField';

const defaultFormat = (props) => props.value;

function withPreview<P>(Component, hocFormat: Format<P> = defaultFormat) {
	function WithPreviewHoc(props: P & PreviewProps<P>) {
		const {
			previewMode,
			format = hocFormat,
			hasBottomLine,
			breakWord,
			textEllipsis,
			placeholder,
			previewUrl,
			previewValueClassName,
			fullValueTooltip,
			...componentProps
		} = props;

		if (previewMode) {
			return (
				<PreviewValue
					hasBottomLine={hasBottomLine}
					breakWord={breakWord}
					textEllipsis={textEllipsis}
					placeholder={placeholder}
					previewUrl={previewUrl}
					style={componentProps.style}
					previewValueClassName={previewValueClassName}
					/* @ts-ignore  */
					title={fullValueTooltip ? componentProps.value : undefined}
				>
					{/* @ts-ignore  */}
					{format(componentProps)}
				</PreviewValue>
			);
		}

		return (
			<Component
				{...componentProps}
				placeholder={placeholder}
			/>
		);
	}

	return WithPreviewHoc;
}

export { withPreview };
